<template>
  <div class="settings_right">
    <div class="content-header">
      <div class="content-header-left">
        <div class="search">
          <vs-input :key="'searchtxt'"
            icon-pack="feather"
            icon="icon-search"
            v-model="searchtxt"
            placeholder="Search by Name"
            class="is-label-placeholder"
          />
        </div>
      </div>
      <div class="content-header-right">
      <vs-inv-dropdown >
       <!-- <vs-dropdown vs-custom-content vs-trigger-click>
          <vs-button
            color="primary"
            class="filter-btn"
            type="border"
            icon-pack="feather"
            icon="icon-chevron-down"
            icon-after
          >
            <img src="@/assets/images/main/icon-filter.svg" /> Filters
          </vs-button> -->
          <!-- <vs-dropdown-menu ref="filter_menu" class="filters-content"> -->
          <div class="filters-content coltwo">
            <div class="filters-form-fileds noscroll">
              <div class="form-container">
                <div class="vx-row">
                                   

                  <div class="vx-col md:w-1/3 w-full con-select" v-if="false">
                    <label class="typo__label">Select Status</label>
                    <multiselect
                      v-model="selected_statusids"
                      :options="[{'name':'Deleted' ,'id':false} ,{'name':'Active' ,'id':true}]"
                      :multiple="true"
                      :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Status"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                      <template
                        slot="selection"
                        slot-scope="{ values, isOpen }"
                      >
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && !isOpen"
                          >{{ values.length }} Status Selected</span
                        >
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>

                  <div class="vx-col md:w-1/2 w-full con-select">
                    <label class="typo__label">Case Type</label>
                    <multiselect
                      v-model="filteredServiceCenters"
                      :options="caseTypeList"
                      :multiple="true"
                      :hideSelected="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      placeholder="Select Case Type"
                      label="name"
                      track-by="name"
                      :preselect-first="false"
                    >
                      <template
                        slot="selection"
                        slot-scope="{ values, isOpen }"
                      >
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && !isOpen"
                          >{{ values.length }} Case Type(s) Selected</span
                        >
                        <span
                          class="multiselect__selectcustom"
                          v-if="values.length && isOpen"
                        ></span>
                      </template>
                    </multiselect>
                  </div>

                  <div class="vx-col md:w-1/2 w-full con-select">
                    <label class="typo__label">Created Date</label>
                    <date-range-picker
                      :maxDate="new Date()"
                      :autoApply="autoApply"
                      :ranges="false"
                      v-model="selected_createdDateRange"
                      :opens="'left'"
                    ></date-range-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="filters-status">
              <div class="left-buttons"></div>
              <div class="right-buttons">
                <vs-button
                  color="success"
                  class="save"
                  type="filled"
                  v-on:click="set_filter()"
                  >Apply</vs-button
                >
                <vs-button
                  color="dark"
                  class="cancel"
                  type="filled"
                  v-on:click="clear_filter($event)"
                  >Clear</vs-button
                >
              </div>
            </div>
          </div>
          <!-- </vs-dropdown-menu>
        </vs-dropdown> -->
      </vs-inv-dropdown> 
        <vs-button
          type="border"
         
          class="light-blue-btn"
          @click="addNew()"
          >New Service Center<span>
            <img
              class="add-user-icon ml-2"
              src="@/assets/images/main/add-user.svg"
            />
          </span>
        </vs-button>
      </div>
    </div>
    <!--- You haven\'t  created any User Roles yet. Create a User Roles to start using the ImmiBox ---->
    <NoDataFound
      ref="NoDataFoundRef"
      v-if="list.length == 0"
      :content="callFromSerch ? '' : ''"
      :heading="callFromSerch ? 'No Results Found' : 'No Service Centers Found'"
      type="User Roles"
    />

    <div class="accordian-table" v-if="list.length > 0">
      <vs-table :data="list" :no-data-text="'No data found..!'">
        <template slot="thead" v-if="list.length > 0">
        <!-- "path": "createdOn", // name, createdByName, typeName-->
          <vs-th>
            <a
              @click="sortMe('name')"
              v-bind:class="{
                sort_ascending: sortKeys['name'] == 1,
                sort_descending: sortKeys['name'] != 1,
              }"
            >
              Name
            </a>
          </vs-th>
          <vs-th>
            <a
              @click="sortMe('typeName')"
              v-bind:class="{
                sort_ascending: sortKeys['typeName'] == 1,
                sort_descending: sortKeys['typeName'] != 1,
              }"
            >
              Case Type
            </a>
          </vs-th>
          <vs-th>
            Petitioner's Office State(s)
          
          </vs-th>
          
          <vs-th><a
              @click="sortMe('createdOn')"
              v-bind:class="{
                sort_ascending: sortKeys['createdOn'] == 1,
                sort_descending: sortKeys['createdOn'] != 1,
              }"
            >Created On</a></vs-th>
             <vs-th><a
              @click="sortMe('updatedOn')"
              v-bind:class="{
                sort_ascending: sortKeys['updatedOn'] == 1,
                sort_descending: sortKeys['updatedOn'] != 1,
              }"
            >Updated On</a></vs-th>
           
          <vs-th class="actions">Actions</vs-th>
        </template>

        <template>
          <template v-for="(tr, indextr) in list">
            <vs-tr
             
              :data="tr"
              :key="indextr"
            >
             <vs-td :data="tr"> {{ checkProperty( tr ,'name') }}</vs-td>
              <vs-td :data="tr"> {{ checkProperty( tr,'typeDetails' ,'name') }}</vs-td>
              <vs-td>

                <template v-if="checkProperty(tr, 'stateNames', 'length') > 0">
                  {{ tr.stateNames[0] }}
                </template>

                <div class="menu_dropdown flexible_actions email_list right ml-2"
                  v-if="checkProperty(tr, 'stateNames', 'length') > 1">
                  <em class="more_count ">
                    +{{ tr['stateNames'].length - 1 }}
                  </em>
                  <div class="menu_list_wrap" v-if="checkProperty(tr, 'stateNames', 'length') > 1">
                    <ul class="">
                      <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--main-sidebar" :settings="settings"
                        @ps-scroll-y="psSectionScroll">
                        <template v-for="( name, eind ) in tr['stateNames']">
                          <li v-if="eind > 0" :key="eind">{{ name }}</li>
                        </template>

                      </VuePerfectScrollbar>

                    </ul>

                  </div>
                </div>
                </vs-td>




             <vs-td >{{tr['createdOn'] | formatDate}} </vs-td>
             <vs-td  class="td_label"> 
             
              <template v-if=" checkProperty( tr,'updatedOn')">  {{ checkProperty( tr,'updatedOn') | formatDate }}</template>
               <!---  <small> {{ checkProperty(tr ,'createdByRoleName') }} </small>--->
              </vs-td>
              <vs-td >
                <vs-dropdown class="msg_dropdown_icon" :vs-trigger-click="true">
                  <a class="a-icon" href.prevent
                    ><more-vertical-icon
                      size="1.5x"
                      class="custom-class"
                    ></more-vertical-icon
                  ></a>
                  
                  <vs-dropdown-menu class="loginx msg_dropdown">
                    <vs-dropdown-item v-if="(tr.tenantId==null && [1,2].indexOf(getUserRoleId)>-1) || (tr.tenantId!=null && [3,4].indexOf(getUserRoleId)>-1)">
                      <a
                        style="cursor: pionter; padding: 3px 10px"
                        href.prevent
                        @click="editMe(tr)"
                        >Edit</a
                      >
                    </vs-dropdown-item>
                    <vs-dropdown-item  >
                     <a @click="deleteMe(tr)"  href.prevent><p style="cursor:pionter"  >Delete</p></a>
                   </vs-dropdown-item>
                    
                      <vs-dropdown-item>
                      <a
                        style="cursor: pionter; padding: 3px 10px"
                        href.prevent
                        @click="showViewModal(tr)"
                        >View</a
                      >
                    </vs-dropdown-item>
                    

                 
                  </vs-dropdown-menu>
                </vs-dropdown>
              </vs-td>
            </vs-tr>
          </template>
        </template>
      </vs-table>
      <div class="table_footer">
        <div class="vx-col  con-select pages_select"  v-if="list.length>0">
          <label class="typo__label">Per Page</label>
          <multiselect @input="changeperPage()" v-model="perpage" :options="perPeges" :multiple="false"
              :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Per Page"
              :preselect-first="true" :allow-empty="false">
            </multiselect>
            <span class="totla_list_count" v-if="totalCount"> Total <em>{{totalCount}}</em></span>
          </div>
          <paginate
        v-if="list.length > 0"
        v-model="page"
        :page-count="totalpages"
        :page-range="3"
        :margin-pages="2"
        :click-handler="pageNate"
        prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
        next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
        :prev-text="'<i></i>'"
        :next-text="'<i></i>'"
        :container-class="'pagination vs-pagination--nav'"
        :page-class="'page-item'"
      ></paginate>
      </div>
      
    </div>



     <modal
      name="serviceCenterModel"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="500px"
      height="auto"
    >
     <div class="v-modal" >
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">
            {{ edit ? "Edit Service Center" : "Add Service Center" }}
          </h2>
          <span @click="hideModel('serviceCenterModel')">
            <em class="material-icons">close</em>
          </span>
        </div>
        <form @submit.prevent>
          <div class="form-container" @click="formerrors.msg=''">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="form_group d-block">
                  <label class="form_label">Name<em>*</em></label>
                  <vs-input :key="'title'"
                    v-model="newform.name"  
                    name="title"
                    v-validate="'required'"
                    class="w-full"
                    data-vv-as="Name"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('title')"
                    >{{ errors.first("title") }}</span
                  >
                </div>
              </div>
             </div>
             
            <div class="vx-row">
              <div class="vx-col w-100"   >
                <div class="form_group d-block">
                  <label class="form_label">Case Type<em>*</em></label>
                    <div class="con-select w-full">
                  
                      <multiselect
                        name="desiredsoccode"
                        v-model="newform.typeDetails"
                        :options="caseTypeList"
                        :multiple="false"
                        :close-on-select="true"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Select Case Type"
                        label="name"
                        track-by="id"
                        :preselect-first="false"
                        data-vv-as=" Case Type"
                        v-validate="'required'"
                        
                        
                      
                      > 
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span
                          class="multiselect__selectcustom"
                          v-if="values.length && !isOpen"
                          >{{ values.length }} Case Type(s) Selected</span
                          >
                          <span
                          class="multiselect__selectcustom"
                          v-if="values.length && isOpen"
                          ></span>
                        </template>
                      </multiselect>
                      <span   class="text-danger text-sm" v-show="errors.has('desiredsoccode')"  >{{ errors.first("desiredsoccode") }}</span>
                    </div>
                </div>
              </div>
              <div class="vx-col w-100"   >
                <div class="form_group d-block">
                  <label class="form_label">Petitioner's Office State(s)</label>
                    <div class="con-select w-full">
                  
                      <multiselect
                        name="usState"
                        v-model="newform.stateDetails"
                        :options="usStatesList"
                        :multiple="true"
                        :hideSelected="true" 
                        :close-on-select="false"
                        :clear-on-select="false" 
                        :preserve-search="true"
                        placeholder="Select Petitioner's Office State"
                        label="name"
                        track-by="id"
                        :preselect-first="false"
                        data-vv-as="Petitioner's Office State"
                        v-validate="''"
                      > 
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span
                          class="multiselect__selectcustom"
                          v-if="values.length && !isOpen"
                          >{{ values.length }} Petitioner's Office State(s) Selected</span
                          >
                          <span
                          class="multiselect__selectcustom"
                          v-if="values.length && isOpen"
                          ></span>
                        </template>
                      </multiselect>
                      <!-- <span   class="text-danger text-sm" v-show="errors.has('usState')"  >{{ errors.first("usState") }}</span> -->
                    </div>
                </div>
              </div>
              <div class="vx-col w-100" v-if="false"  >
            <div class="form_group d-block">
              <label class="form_label">Address<em>*</em></label>
                <div class="con-select w-full">
                
                  <!-- <vs-textarea
                  class="w-full"
                  v-model="newform.address"
                  v-validate="'required'"
                  data-vv-as="Address"
                  name="Address"
                /> -->
                <ckeditor class="w-full"
                  v-model="newform.address"
                  v-validate="'required'"
                  data-vv-as="Address"
                  name="Address"  :editor="editor" :config="editorConfig"></ckeditor>

                <span
                  class="text-danger text-sm"
                  v-show="errors.has('Address')"
                  >{{ errors.first("Address") }}</span
                >
                </div>
            </div>
              </div>
             </div>
            
              <template v-if="checkProperty(newform,'addressConfig') && checkProperty(newform,'addressConfig','length')>0 && masterCourierList && checkProperty(masterCourierList,'length')>0  " >
                <div class="vx-row" style="margin: 0 -25px"> 
                <template v-for="(item,inder) in newform['addressConfig'] "> 
                  <div class="address_bg" :class="{'border_top': checkProperty(newform,'addressConfig','length') > 1}">
                    <div class="vx-col w-100" :key="inder" >
                    <div class="form_group d-block">
                      <label class="form_label">Courier<em>*</em></label>
                      <div class="con-select w-full">
                        <multiselect
                          data-vv-as="Courier"
                          v-model="item.courierDetails"
                          @input="item.courierId=item.courierDetails['id'];updateCourierList()"
                          :options="optionCourierList"
                          :multiple="false"
                          :close-on-select="true"
                          :clear-on-select="false"
                          :preserve-search="true"
                          placeholder="Select Courier"
                          label="name"
                          track-by="name"
                          :preselect-first="false"
                          :name="'Courier'+inder"
                          v-validate="'required'"
                          
                        >
                          <template slot="selection" slot-scope="{ values,  isOpen }">
                            <span
                              class="multiselect__single"
                              v-if="values.length &amp;&amp; !isOpen"
                            >{{ values.length }} options selected</span>
                          </template>
                        </multiselect>
                      </div>
                      <span class="text-danger text-sm"  v-show="errors.has('Courier'+inder)">{{ errors.first("Courier"+inder) }}</span>
                    </div>
                  </div>
                  <div class="vx-col w-100"   >
                    <div class="form_group d-block">
                      <label class="form_label">Address<em>*</em></label>
                        <div class="con-select w-full">
                        <ckeditor class="w-full"
                          v-model="item.address"
                          v-validate="'required'"
                          data-vv-as="Address"
                          :name="'Address'+inder"  :editor="editor" :config="editorConfig"></ckeditor>

                        <span
                          class="text-danger text-sm"
                          v-show="errors.has('Address'+inder)"
                          >{{ errors.first("Address"+inder) }}</span
                        >
                        </div>
                    </div>
                  </div>
                  <div
                    class="delete"
                    v-if="checkProperty(newform,'addressConfig','length') > 1"
                    @click="removeAddressConfig(inder)"
                  >
                    <a>
                      <img src="@/assets/images/main/delete-row-img.svg" />
                    </a>
                  </div>
                  </div>
                </template>
                <vs-row class="more_btn_wrap" v-if="checkProperty(newform,'addressConfig','length') < checkProperty(masterCourierList,'length') ">
                  <vs-col
                    class="float-none pl-6 pt-0 pb-5 more_btn"
                    vs-type="flex"
                    vs-align="center"
                  >
                    <a @click="addAddressConfig()" class="add-more ml-1" type="filled">
                      <span>+</span> More
                    </a>
                  </vs-col>
                </vs-row>
              </div>
              </template>
            <div class="vx-row" v-if="[9,4].indexOf(checkProperty(newform,'typeDetails','id'))<=-1"> 
            <immiswitchyesno wrapclass=""  :display="true" :fieldsArray="[]" :cid="'premiumProcessing'"   v-model="newform.premiumProcessing"  :fieldName="'premiumProcessing'"   label="Premium Processing" placeHolder="" />
           
            </div>
            
       
       <!---
           <addressFields
           :addFormContainerCls="false"
          :showaptType="true"
          :countries="countries"
          v-model="newform.address"
          :cid="'servrcenteraddress'"
          ref="servrcenteraddress"
        />
        --->


          
            <div class="text-danger text-sm formerrors" v-show="formerrors.msg">
                  <vs-alert
                    color="warning"
                    class="warning-alert reg-warning-alert no-border-radius  mb-0"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >{{ formerrors.msg }}</vs-alert>
            </div>
             
              
          </div>

           
          <div class="popup-footer relative">
            <vs-button
              color="dark"
              @click="hideModel();  "
              class="cancel"
              type="filled"
              >Cancel</vs-button
            >

            <vs-button
              :disabled="creatingNew"
              v-if="edit"
              color="success"
              class="save"
              @click="updateAction()"
              type="filled"
              >Update</vs-button
            >

            <vs-button
              :disabled="creatingNew"
              v-else
              color="success"
              class="save"
              @click="createNewAction()"
              type="filled"
              >Save</vs-button
            >
          </div>
        </form>
      </div>


       
        </modal>
 


       <modal
      name="serviceCenterViewModal"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="500px"
      height="auto"
    >
     <div class="v-modal" >
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Service Center Details</h2>
          <span @click="hideViewModal()">
            <em class="material-icons">close</em>
          </span>
        </div>
       
          <div class="form-container">

           <div class="vx-row" >
              <div class="vx-col w-1/2"  v-if="checkProperty(selectedItem ,'name')" >
                <div class="form_group d-block">
                 <label class="form_label">Name</label>
                  <span>{{ checkProperty(selectedItem ,'name') }}</span>
                </div> 
              </div> 
            
            
              <div class="vx-col w-1/2"  v-if="checkProperty(selectedItem ,'typeDetails' ,'name')"  >
                <div class="form_group d-block">
                 <label class="form_label">Case Type</label>
                  <span>{{ checkProperty(selectedItem ,'typeDetails' ,'name') }}</span>
                </div> 
              </div> 
              <div class="vx-col w-full"  v-if="checkProperty(selectedItem ,'states') && checkProperty(selectedItem ,'states') !='' "  >
                <div class="form_group d-block">
                 <label class="form_label">Petitioner's Office State(s)</label>
                  <span>{{ checkProperty(selectedItem ,'states') }}</span>
                </div> 
              </div> 
              <template v-if="checkProperty(selectedItem ,'addressConfig') && checkProperty(selectedItem ,'addressConfig','length')>0">
                <template v-for="(item,indeer) in selectedItem['addressConfig']">
                  <div class="vx-col w-100"  v-if="checkProperty(item ,'courierDetails') && checkProperty(item ,'courierDetails','name')" >
                    <div class="form_group d-block">
                      <label class="form_label">Courier Name</label>
                      <span>{{ checkProperty(item ,'courierDetails','name') }}</span>
                    </div> 
                  </div> 
                  <div class="vx-col w-100"  v-if="checkProperty(item ,'address')" >
                    <div class="form_group d-block">
                      <label class="form_label">Address</label>
                      <span v-html="checkProperty(item ,'address')"></span>
                    </div> 
                  </div> 
                </template>
              </template>
            
            
              <div class="vx-col w-100"  v-if="checkProperty(selectedItem ,'address')" >
                <div class="form_group d-block">
                <label class="form_label">Address</label>
                  <span v-html="checkProperty(selectedItem ,'address')"></span>
                </div> 
              </div> 
            </div>  
          
          
          </div>
           <div class="popup-footer relative">
            <vs-button
              color="dark"
              @click="hideViewModal();  "
              class="cancel"
              type="filled"
              >Cancel</vs-button
            >
        </div> 
        </div>
        </modal> 
    

    <modal
      name="serviceCenterDeleteModel"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="500px"
      height="auto"
    >
     <div class="v-modal" >
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Service Center Delete</h2>
          <span @click="$modal.hide('serviceCenterDeleteModel')">
            <em class="material-icons">close</em>
          </span>
        </div>
       
          <div class="form-container" @click="formerrors.msg =''" >
            <div class="vx-row">
              <div class="vx-col w-100"   >
                <div class="form_group d-block">
                  <span> Do you want to Delete?</span>
                </div> 
              </div> 
            </div>     

          <div class="text-danger text-sm formerrors" v-show="formerrors.msg" >
                  <vs-alert
                    color="warning"
                    class="warning-alert reg-warning-alert no-border-radius  mb-0"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >{{ formerrors.msg }} </vs-alert>
            </div>
          
          </div>
           <div class="popup-footer relative">
            <vs-button
             :disabled="deleting"
              color="dark"
              @click="$modal.hide('serviceCenterDeleteModel');  "
              class="cancel"
              type="filled"
              >No</vs-button
            >
             <vs-button
              :disabled="deleting"
             
              color="success"
              class="save"
              @click="deleteServiceCenter()"
              type="filled"
              >Yes</vs-button
            >
        </div> 
        </div>
        </modal> 

    
  </div>
</template>

<script>
import vsInvDropdown from "@/views/vs-inv-dropdown.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import DateRangePicker from "vue2-daterange-picker";
import Datepicker from "vuejs-datepicker-inv";
import Paginate from "vuejs-paginate";
import immiswitchyesno from "@/views/forms/fields/switchyesno.vue";
import immiyesorno from "@/views/forms/fields/yesorno.vue";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import _ from "lodash";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import moment from "moment";
import PhoneMaskInput from "vue-phone-mask-input";
import JQuery from "jquery";
import { TheMask } from "vue-the-mask";

import FileUpload from "vue-upload-component/src";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { MoreVerticalIcon } from "vue-feather-icons";
import NoDataFound from "@/views/common/noData.vue";
import Vue from 'vue';
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

//import addressFields from "@/views/common/addressForm.vue";
import addressFields from "@/views/forms/fields/address.vue";
export default {
   provide() {
        return {
            parentValidator: this.$validator,
        };
    },
  computed: {
     acceptedFiles(){
      let returnValue ='*';
     
          returnValue ='application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        

     
      return returnValue;
      //image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document
    }
    
  },
  components: {
    vsInvDropdown,
    VuePerfectScrollbar,
    immiswitchyesno,
   // addressFields,
   immiyesorno,
    NoDataFound,
    DateRangePicker,
    VuePhoneNumberInput,
    Datepicker,
    Paginate,
    FileUpload,
    FormWizard,
    TabContent,
    PhoneMaskInput,
    TheMask,
    MoreVerticalIcon,
    
  },

  data: () => ({
    settings: {
      swipeEasing: true,
    },
    optionCourierList:[],
    masterCourierList:[],
    editor: ClassicEditor,
 editorConfig: {
     toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
 },

    deleting:false,
    caseTypeList:[],
    usStatesList:[],
    filteredServiceCenters:[],
selected_statusids:[],
    countries:[],
    value:[],
    uploading:false,
      allTags:[],
      creatingNew: false,
      caseTypeList:[],
    
    callFromSerch: false,
    selected_createdDateRange: ["", ""],
    autoApply: "",
    value: [],
    selectedItem: null,
   formerrors: {
      msg: "",
    },
    date: null,
    approveConformpopUp: false,

    newform: {
      name: "", 
      description: "" ,
      typeId:'' ,
      typeDetails:null,
      stateDetails:[],
      stateIds:[],
      "address": "",
      addressConfig:[{
        courierId: '',
        address: "",
        courierDetails:null,
      }],
      premiumProcessing:false,
    /*{
        line1: "",
        line2: "",
        zipcode: "",
        countryId:null,
        countryDetails: null,
        stateId:null,
         locationId:null,
        stateDetails: null,
        locationDetails: null,
        aptType:'',
      }
      */
    },
    list: [],
    addPopup: false,
    searchtxt: "",
    query: [],
    

    date: "",
    date_range: [],
    page: 1,
      perPeges: [10,25,50,75,100],
      perpage: 25,
      totalCount:0,
      totalpages: 0,
     edit: false,
    sortKeys: {},
    sortKey: {},
    
  }),
  watch: {
    searchtxt: function (value) {
      let self =this;
      this.page = 1;
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        self.getList(true);
      }, 900)
    },
  },
  methods: {
    psSectionScroll() { },
    changeperPage(){
        this.page = 1;
        this.getList(true);
      },
    removeAddressConfig(index){
      this.newform.addressConfig.splice(index, 1);
      this.updateCourierList()
    },
    updateCourierList(){
      if(this.masterCourierList && this.checkProperty(this.masterCourierList,'length')>0){
       // let activytList =  _.find(this.workFlowDetails.config , {"code":listcode}); 
        this.optionCourierList = [];
        this.optionCourierList = _.filter(this.masterCourierList,(item)=>{
          let obj = _.find(this.newform['addressConfig'],{'courierId':item['id']})
          if(!obj){
            return item
          }
        })
      }
    },
    addAddressConfig(){
      this.$validator.validateAll().then((result) => {
        if(result){
          let obj={
            courierId: '',
            courierName: "",
            address: ""
          }
          this.newform['addressConfig'].push(obj)
        }
      })
    },
     downloadFile(document){
       // alert(this.$globalgonfig._APIURL+"/common/viewfile?path="+document.path);
         window.open(this.$globalgonfig._APIURL+"/common/viewfile?path="+document.path, "_blank");
      },
      upload(files ,type="") {
        let model = _.cloneDeep(files);
      //  this.value = [];
      this.newform['document'] =null;
      this.newform['attachments'] = [];

            var _current = this;
           // this.$vs.loading();
          
           
            let tempFiles =[]
            if (model.length > 0) {
                this.uploading =true;
                model.forEach((doc, index) => {
                    let formData = new FormData();                  
                    formData.append("files", doc.file);
                    formData.append("type", "forms-and-letters");
                    formData.append("secureType", "private");
                    formData.append("getDetails", true);
                    
                     //uploadLocal
                     //uploadS3File

                    this.$store.dispatch("uploadLocal", formData).then((response) => {
                        response.data.result.forEach((urlGenerated) => {
                            doc.url = urlGenerated;
                            delete doc.file;
                             let temp_file = urlGenerated;
                             
                           
                          tempFiles.push(temp_file);
                          let fl = { "name":temp_file['name'] ,"url":temp_file['path'] , "mimetype":temp_file['mimetype']} ;
                          this.newform.document =  urlGenerated ;
                          this.newform.attachments.push(fl);
                        
                         this.uploading =false;
                         this.$vs.loading.close();
                         if (tempFiles.length >= model.length) {
                              _current.$vs.loading.close();
                          }   
                       
                       });
                    
                    });

                 
               });
                
               
            }     
              //  model.splice(0, mapper.length, ...mapper);
            
    },
    remove(item, data ,filindex) {
            data.splice(filindex, 1);
            this.newform.document =null;
    
    },
      showViewModal(item){
        this.edit= false;
            this.selectedItem =_.cloneDeep(item);
             let typeDetails = _.find(this.caseTypeList , {"id":this.selectedItem['typeId']})
             this.selectedItem = Object.assign(this.selectedItem ,{ "typeDetails":typeDetails});
             this.$modal.show('serviceCenterViewModal');

      },
      hideViewModal(){
          this.$modal.hide('serviceCenterViewModal');
      },
      
      async  copyTag(text=''){
          
        try {
          await navigator.clipboard.writeText(text);
                   
        
        } catch ($e) {
        
        
        }
      
    
    },
      onSelectSoc(){

      },
      setNewForm(){

        
           this.newform = { 
            stateDetails:[], 
            stateIds:[],
              name: "", 
            description: "" ,
            typeId:'' , 
            typeDetails:null ,
            document:null,
            "attachments":[],
            "address": "",
            addressConfig:[{
              courierId: '',
              address: "",
              courierDetails:null,
            }],
            premiumProcessing:false,
          /*  {
                line1: "",
                line2: "",
                zipcode: "",
                countryId:null,
                countryDetails: null,
                stateId:null,
                locationId:null,
                stateDetails: null,
                locationDetails: null,
                aptType:'',
              } */
           } ;
           this.value = [];
           if(this.edit){
              
           }
           this.$validator.reset();
      },
     
      addNew(){
          this.setNewForm()
          this.addPopup =true;
          this.edit =false;
          this.creatingNew = false;
          this.optionCourierList = this.masterCourierList;
          this.$modal.show('serviceCenterModel');
          setTimeout(()=>{
            this.$validator.reset();
          })
          
         Object.assign(this.formerrors, { msg: "" });
         
      },
      hideModel(){
          this.addPopup =false;
          this.edit =false;
          this.creatingNew = false;
         Object.assign(this.formerrors, { msg: "" });
         this.$modal.hide('serviceCenterModel');
          this.setNewForm()

      },
    sortMe(sort_key = "") {
      if (sort_key != "") {
        this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1;
        // this.sortKey[sort_key] = this.sortKeys[sort_key]
        this.sortKey = { path: sort_key, order: this.sortKeys[sort_key] };

        localStorage.setItem("userroles_sort_key", sort_key);
        localStorage.setItem("userroles_sort_value", this.sortKey[sort_key]);
        this.getList();
      }
    },
    editMe(item) {
          this.setNewForm()
      this.edit = true;
    
      this.selectedItem = _.cloneDeep(item);
      Object.assign(this.formerrors, { msg: "" });
      let list = [];
      if(this.checkProperty(this.selectedItem, 'stateIds', 'length')>0 && this.checkProperty(this.usStatesList, 'length')>0){
      _.forEach(this.selectedItem['stateIds'], (item)=>{
        let findObj = _.find(this.usStatesList, {'id':item});
        if(findObj){
          list.push(findObj)
        }
      })
    }
    this.selectedItem = Object.assign(this.selectedItem ,{ "stateDetails":list});
     this.newform =_.cloneDeep( this.selectedItem);
     let typeDetails = _.find(this.caseTypeList , {"id":this.selectedItem['typeId']})
    this.newform = Object.assign(this.newform ,{ "typeDetails":typeDetails});
   
       this.newform =   this.newform;
      this.addPopup = false;
      this.creatingNew = false;
      this.updateCourierList();
       this.$modal.show('serviceCenterModel');
       this.$validator.reset();
    },
    deleteMe(item){
       this.selectedItem = _.cloneDeep(item);
       this.deleting =false;
       this.formerrors.msg =''
       this.$modal.show('serviceCenterDeleteModel');
    },

    deleteServiceCenter(){

       if(_.has(this.selectedItem ,"_id")){
               this.creatingNew = true;
             let  postData = _.cloneDeep(this.newform);
             postData['serviceCenterId'] = this.selectedItem['_id'];
             this.deleting =true;
               this.$store
              .dispatch("commonAction", {"data":postData ,"path":"/service-centers/delete"})
              .then(response => {
               
                //lca_request_msg
                this.$modal.hide('serviceCenterDeleteModel');
                  this.getList();
                 this.showToster({message:response.message,isError:false });
                
                  this.deleting = false;
                
                                
              })
              .catch((error)=>{
               
                Object.assign(this.formerrors, { msg: error });
                 this.deleting = false;
              })
          }

    },

    createNewAction() {
     
      Object.assign(this.formerrors, { msg: "" });
      this.$validator.validateAll().then((result) => {
          if(result){
               this.creatingNew = true;
             let  postData = _.cloneDeep(this.newform);
              postData['typeId'] = this.checkProperty( this.newform , "typeDetails" ,"id");
              if(this.checkProperty( this.newform , "stateDetails", 'length')>0){
                let stateIds = _.map(this.newform['stateDetails'], 'id');
                postData['stateIds'] = stateIds;
              }
             // postData['address']='address';
                this.$store
              .dispatch("commonAction", {"data":postData ,"path":"/service-centers/create"})
              .then(response => {
               
                //lca_request_msg
                 this.getList();
                 this.showToster({message:response.message,isError:false });
                 this.hideModel();
                  this.creatingNew = false;
                
                                
              })
              .catch((error)=>{
                Object.assign(this.formerrors, { msg: error});
                 this.creatingNew = false;
              })
          }
      })
    
    },

     updateAction() {
     
      Object.assign(this.formerrors, { msg: "" });
      this.$validator.validateAll().then((result) => {
          if(result){
               this.creatingNew = true;
             let  postData = _.cloneDeep(this.newform);
             postData['serviceCenterId'] = this.selectedItem['_id'];
             postData['typeId'] = this.checkProperty( this.newform , "typeDetails" ,"id")
             if(this.checkProperty( this.newform , "stateDetails", 'length')>0){
                let stateIds = _.map(this.newform['stateDetails'], 'id');
                postData['stateIds'] = stateIds;
              }
               this.$store
              .dispatch("commonAction", {"data":postData ,"path":"/service-centers/update"})
              .then(response => {
               
                //lca_request_msg
                  this.getList();
                 this.showToster({message:response.message,isError:false });
                 this.hideModel();
                  this.creatingNew = false;
                
                                
              })
              .catch((error)=>{
                Object.assign(this.formerrors, { msg: error });
                 this.creatingNew = false;
              })
          }
      })
    
    },

     getDetails(){
        let  postData ={'serviceCenterId':''};
        postData['serviceCenterId'] = this.checkProprty(this.selectedItem , '_id');
        this.$store
        .dispatch("commonAction", {"data":postData ,"path":"/service-centers/details"})
        .then(response => {
        
          this.showToster({message:response.message,isError:false });
                
                        
        })
        .catch((error)=>{
              this.showToster({message:error,isError:false });
        })
     
    
    },

    

    getList(callFromSerch = false) {
      this.callFromSerch = callFromSerch;
      if (this.callFromSerch) {
        this.list = [];
      }
      this.updateLoading(true);
    
      let matcher = {
        title: this.searchtxt,
        status:[],
        typeIds:[],
        createdDateRange: [],
      };
        //this.selected_statusids = [];
    // this.filteredServiceCenters = [];
      if(this.selected_statusids.length>0 ){
        matcher['status'] = this.selected_statusids.map((item)=>item.id)
      }
       if(this.filteredServiceCenters.length>0 ){
        matcher['typeIds'] = this.filteredServiceCenters.map((item)=>item.id)
      }
      if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        matcher["createdDateRange"] = [
          this.selected_createdDateRange["startDate"],
          this.selected_createdDateRange["endDate"],
        ];
      }

      let query = {};
      query["page"] = this.page;
      query["perpage"] = this.perpage;
      query["filters"] = matcher;
      query["sorting"] = this.sortKey;
   
     this.$store.dispatch("commonAction", {"data":query ,"path":"/service-centers/list"})
        .then((response) => {
          let tempList = response.list;
          if (tempList && this.checkProperty(tempList, 'length') > 0) {
            _.forEach(tempList, (item) => {
              let namesList = [];
              let states = '';
              if (_.has(item, 'stateList') && this.checkProperty(item, 'stateList') && this.checkProperty(item, 'stateList', 'length')>0) {
                _.forEach(item['stateList'], (it)=>{
                  namesList.push(it['name'])
                })
              }
              if(namesList && namesList.length>0){
                states = namesList.join(', ');
              }
              
              Object.assign(item, { 'stateNames': namesList, 'states':states });
              namesList = [];
            })
            this.list = tempList;
          }
          this.updateLoading(false);
          this.totalCount = this.checkProperty(response, 'totalCount');
          this.totalpages = Math.ceil(response.totalCount / this.perpage);
          //alert(this.perpage);
        })
        .catch(() => {
          this.list = [];
          this.updateLoading(false);
        });
    },
 
    set_filter: function () {
      // this.$refs["filter_menu"].dropdownVisible = false;
      document.body.classList.remove('scroll-hidden');
      this.getList(true);
    },
    clear_filter: function () {
      this.filteredServiceCenters =[];
      this.selected_statusids =[];
      this.searchtxt = "";
      // this.$refs["filter_menu"].dropdownVisible = false;
      document.body.classList.remove('scroll-hidden');
      
      this.selected_createdDateRange["startDate"] = "";
      this.selected_createdDateRange["endDate"] = "";
      this.getList();
    },
    pageNate(pageNum) {
      this.page = pageNum;
      this.getList();
    },
    getCourierList() {
            let postdata = {};
            
this.$store
        .dispatch("getList", { data: postdata, path: "/tracking/courierlist" }).then((response) => {
            if (this.checkProperty(response, "list")) {
                 this.masterCourierList = response['list'];
                 this.optionCourierList = response['list'];
            }

            
            });
        },

    
  },
  mounted() {
    this.getCourierList();
    this.$store.dispatch("getstates", 231).then((response) => {
      this.usStatesList = response;
    }).catch((err)=>{

    })
    this.$store
      .dispatch("getmasterdata", "petition_types")
      .then((response) => {
        this.caseTypeList = response;
        //this.upDatehighestDegree();
      });
    this.$store.dispatch("getcountries").then(response => {
      this.countries = response;
    })
    
    
    let loginRoleId = this.getUserRoleId;
          this.allowed_roles = [2,3,4, 5, 6, 7, 8, 9, 10, 11,12,13];

    if (loginRoleId == 3) {
      this.allowed_roles = [4, 5, 6, 7, 8, 9, 10, 11, 13];
    }
    if (loginRoleId == 4) {
      this.allowed_roles = [5, 6, 7, 8, 9, 10, 11, 12];
    }
    if (this.$route.name != "basic-settings") {
      this.$store.dispatch("updateSidebarWidth", "extended");
    }
    //
 
  
    // this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
    this.selected_statusids = [];
    this.filteredServiceCenters = [];
   
    
    this.sortKeys = {
      name: 1,
      type: 1,
      createdOn: -1,
      createdByName: 1,
      typeName:1,
      updatedOn:1
    }

      this.sortKey = { path: "createdOn", order: -1 };
//"createdOn", // name, createdByName, typeName
    
    this.getList();
  },
};
</script>
